module.exports = __webpack_public_path__ + "img/icon-user-default.37c3ea6b.png";